<template>
  <div class="typeArea">
    <div class="box">
        <div class="box-top">
            <defaultImg v-for="item in dataList" :key="item" :src="item.src"></defaultImg>
        </div>
        <div class="pagination mg-top60">
            <el-pagination
                background
                layout="prev, pager, next, jumper"
                :total="1000">
            </el-pagination>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'laboratory',
  data () {
    return {
      dataList:[
        {
          src: require("@/assets/images/laboratory/image1.png"),
        },
        {
          src: require("@/assets/images/laboratory/image2.png"),
        },
        {
          src: require("@/assets/images/laboratory/image3.png"),
        },
        {
          src: require("@/assets/images/laboratory/image4.png"),
        },
        {
          src: require("@/assets/images/laboratory/image5.png"),
        },
        {
          src: require("@/assets/images/laboratory/image6.png"),
        },
        {
          src: require("@/assets/images/laboratory/image7.png"),
        },
        {
          src: require("@/assets/images/laboratory/image8.png"),
        },
        {
          src: require("@/assets/images/laboratory/image9.png"),
        },
        {
          src: require("@/assets/images/laboratory/image10.png"),
        },
        {
          src: require("@/assets/images/laboratory/image11.png"),
        },
        {
          src: require("@/assets/images/laboratory/image12.png"),
        },

      ]
    }
  },
  methods: {},
}
</script> 

<style lang='less' scoped>
    .box{
        margin: 80px 0;
        .box-top{
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            img{
                margin-bottom: 20px;
                height:260px;
                width:345px;
            }
        }
    }
</style>
